<template>
  <div>
    <p class="tw-mb-3 tw-text-base tw-font-medium tw-text-gray-800">
      {{ question.label }}
      <span v-if="!question.is_required" class="tw-text-sm tw-text-gray-400">
        ({{ $t('bz2.event.surveys.optional') }})
      </span>
    </p>

    <!-- Estrellas -->
    <div v-if="question.type === types.stars" class="tw-flex tw-flex-wrap">
      <button
        v-for="n in settings.max"
        :key="n"
        type="button"
        class="tw-p-1 focus:tw-outline-none"
        :aria-label="`${n}`"
        @click="input = n"
      >
        <v-icon :color="input >= n ? 'amber' : 'grey lighten-1'" large>
          {{ input >= n ? 'star' : 'star_border' }}
        </v-icon>
      </button>
    </div>

    <!-- Escala numérica -->
    <div v-else-if="question.type === types.scale">
      <div class="tw-flex tw-flex-wrap tw-gap-2">
        <button
          v-for="n in scale"
          :key="n"
          type="button"
          class="tw-h-10 tw-w-10 tw-rounded-full tw-border tw-text-sm tw-font-semibold tw-transition focus:tw-outline-none focus:tw-ring focus:tw-ring-primary-300"
          :class="
            input === n
              ? 'tw-border-primary-500 tw-bg-primary-500 tw-text-white'
              : 'tw-border-gray-300 tw-bg-white tw-text-gray-700 hover:tw-bg-gray-100'
          "
          @click="input = n"
        >
          {{ n }}
        </button>
      </div>
      <div
        v-if="settings.min_label || settings.max_label"
        class="tw-mt-2 tw-flex tw-justify-between tw-text-xs tw-text-gray-500"
      >
        <span>{{ settings.min_label }}</span>
        <span>{{ settings.max_label }}</span>
      </div>
    </div>

    <!-- Caritas -->
    <div v-else-if="question.type === types.emoji" class="tw-flex tw-gap-3">
      <button
        v-for="(emoji, index) in emojis"
        :key="index"
        type="button"
        class="tw-rounded-full tw-p-1 tw-text-4xl tw-transition focus:tw-outline-none"
        :class="
          input === index + 1
            ? 'tw-scale-110 tw-bg-primary-100'
            : input
            ? 'tw-opacity-40'
            : ''
        "
        @click="input = index + 1"
      >
        {{ emoji }}
      </button>
    </div>

    <!-- Opción única -->
    <v-radio-group
      v-else-if="question.type === types.single_choice"
      v-model="input"
      class="tw-mt-0"
      hide-details
    >
      <v-radio
        v-for="option in settings.options"
        :key="option"
        :label="option"
        :value="option"
      />
    </v-radio-group>

    <!-- Sí / No -->
    <div v-else-if="question.type === types.yes_no" class="tw-flex tw-gap-3">
      <v-btn
        v-for="option in yesNo"
        :key="String(option.value)"
        rounded
        depressed
        :color="input === option.value ? 'primary' : ''"
        @click="input = option.value"
      >
        {{ option.label }}
      </v-btn>
    </div>

    <!-- Comentario -->
    <v-textarea
      v-else-if="question.type === types.text"
      v-model="input"
      outlined
      rounded
      auto-grow
      rows="2"
      :counter="settings.max_length"
      :maxlength="settings.max_length"
      hide-details="auto"
    />
  </div>
</template>

<script>
import {
  SurveyQuestionTypeKeys,
  surveyEmojis,
} from '@/enums/SurveyQuestionTypeKeys'

export default {
  props: {
    question: {
      type: Object,
      required: true,
    },
    value: {
      type: [Number, String, Boolean],
      default: null,
    },
  },
  data: () => ({
    types: SurveyQuestionTypeKeys,
  }),
  computed: {
    input: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
    settings() {
      return this.question.settings || {}
    },
    scale() {
      const { min = 1, max = 10 } = this.settings
      return Array.from({ length: max - min + 1 }, (_, i) => min + i)
    },
    emojis() {
      return surveyEmojis(this.settings.levels)
    },
    yesNo() {
      return [
        { value: true, label: this.$t('bz2.event.surveys.yes') },
        { value: false, label: this.$t('bz2.event.surveys.no') },
      ]
    },
  },
}
</script>
